import React from 'react';
import Heading from '../components/heading/Heading';

const Error = () => {
    return (
        <section className="form">
            <div className="container">
                <div className="thanks">
                    <Heading title="Masz już włączoną zakładkę z kalkulatorem GRENKE - zamknij jedną z nich." />
                </div>
            </div>
        </section>
    )
    
}

export default Error;